import { inject, provide, reactive, toRefs } from 'vue'

const TableContextKey = Symbol('TableContext')

export function useTableContext() {
  // Inject the context. If it doesn't exist, it will return a reactive empty object.
  const context = inject(
    TableContextKey,
    reactive({
      isInsideTable: false,
    })
  )

  return toRefs(context)
}

export function provideTableContext(values) {
  // Get the current context or create a new one if it doesn't exist
  const existingContext = inject(
    TableContextKey,
    reactive({
      isInsideTable: true,
    })
  )

  // Create a new context that merges the parent context with the provided values
  const newContext = reactive({ ...existingContext, ...values })

  // Provide the merged context
  provide(TableContextKey, newContext)
}
